<p-toast></p-toast>
<router-outlet></router-outlet>
<p-confirmDialog
  #cd
  appendTo="body"
  [style]="{ width: '50vw' }"
></p-confirmDialog>
